
import { Component, Prop, Vue } from 'vue-property-decorator';
import { VueCropper } from 'vue-cropper';

import {
  Dialog,
  Upload,
  Card,
  Link,
  Button,
} from 'element-ui';
import api from '@/api/course';

@Component({
  components: {
    Dialog,
    Upload,
    Card,
    Link,
    VueCropper,
    Button,
  },
})

export default class uploadModal extends Vue {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: false,
    default: '图片裁剪',
  }) title!: string;

  @Prop({
    required: false,
  }) row!: any;

  private fileName:any = '';

  private previews: any = {
    w: '200',
    h: '200',
  }

  private option: any = {
    img: null,
    size: 1,
    full: false,
    outputType: 'png',
    canMove: true,
    original: false,
    canMoveBox: true,
    autoCrop: true,
    autoCropWidth: 224,
    autoCropHeight: 168,
    fixedBox: true,
  };

  public $refs!: {
    cropper: any
  }

  mounted() {
    this.option.img = this.row.resourceImage;
  }

  /**
   * @author liangyongmou
   * @desc 获取所有合同图片
   */
  getAttachment() {
    api.getFile(this.row.pid).then((res: any) => {
      this.fileName = res.data.path;
    });
  }

  realTime(data: any) {
    this.previews = data;
  }

  uploadImg(e: any, num: number) {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (el: any) => {
      let data: any = '';
      data = el.target ? el.target.result : '';
      if (num === 1) {
        this.option.img = data;
      }
    };
    reader.readAsDataURL(file);
  }

  changeScale(num: number) {
    this.$refs.cropper.changeScale(num);
  }

  rotateLeft() {
    this.$refs.cropper.rotateLeft();
  }

  rotateRight() {
    this.$refs.cropper.rotateRight();
  }

  upload() {
    this.$refs.cropper.getCropBlob((res: any) => {
      const data = new FormData();
      data.append('pid', this.row.pid);
      data.append('resourceImage', res);
      api.uploadImage(data).then(() => {
        this.reset(true, true);
      });
    });
  }

  // 重置表单
  reset(close: boolean = false, refrsh: boolean = false) {
    if (close) this.$emit('update:visible', false);
    if (refrsh) this.$emit('refrsh');
  }
}
